import { Form, message, Modal } from "antd";
import { Rule } from "antd/lib/form";
import { productPropertyApi } from "api/product-property.api";
import { AppButton, AppInput } from "components/antd-ui";
import { useEffect, useRef, useState } from "react";
import { ModalStatus } from "types/modal";
import { ProductProperty } from "types/product";

const rules: Rule[] = [{ required: true, message: "Bắt buộc" }];

export const ProductPropertyModal = ({
  visible,
  status,
  productProperty,
  onClose,
  onSubmitOk,
  productId,
}: {
  visible: boolean;
  status: ModalStatus;
  productId: number;
  productProperty: Partial<ProductProperty>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<ProductProperty>();
  const [loading, setLoading] = useState(false);
  const productPropertyId = useRef(0);

  useEffect(() => {
    if (status === "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    form.setFieldsValue({ ...productProperty });
    productPropertyId.current = productProperty?.id || 0;
  }, [productProperty]);

  const handleSubmit = async () => {
    await form.validateFields();

    const data = {
      productProperty: form.getFieldsValue(),
      productId,
    };

    setLoading(true);
    try {
      if (status === "create") {
        await productPropertyApi.create(data);
        message.success("Tạo thành công");
      } else {
        await productPropertyApi.update(productPropertyId.current, data);
        message.success("Cập nhật thành công");
      }

      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      style={{ top: 15 }}
      onCancel={onClose}
      open={visible}
      title={
        <h1 className="text-xl font-bold text-center">
          {status === "create" ? "Tạo mới thuộc tính" : "Cập nhật thuộc tính"}
        </h1>
      }
      footer={null}
      width={500}
      className="app-form-modal"
    >
      <div className="app-form-modal__body">
        <section className="app-form-modal__section">
          <Form layout="vertical" form={form}>
            <Form.Item label="Key" name="key" rules={rules}>
              <AppInput placeholder="VD: Sản xuất, màu, ..." />
            </Form.Item>

            <Form.Item label="Giá trị" name="value" rules={rules}>
              <AppInput placeholder="2022, đỏ, ..." />
            </Form.Item>
          </Form>
        </section>
      </div>
      <div className="ant-modal-footer">
        <div className="flex gap-2 justify-end">
          <AppButton onClick={onClose}>Hủy</AppButton>
          <AppButton tone="primary" loading={loading} onClick={handleSubmit}>
            {status === "create" ? "Xác nhận" : "Cập nhật"}
          </AppButton>
        </div>
      </div>
    </Modal>
  );
};
